(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["archive-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('infusion-archive')) {
  customElements.define('infusion-archive', class extends HTMLElement {
    connectedCallback() {
      this.viewer = this.querySelector('dialog');
      if (!this.viewer || typeof this.viewer.showModal !== 'function') return;
      this.fullImage = this.querySelector('[data-archive-full]');
      this.caption = this.querySelector('[data-archive-caption]');
      this.onClick = (event) => {
        const close = event.target.closest('[data-archive-close]');
        if (close) { this.viewer.close(); return; }
        const link = event.target.closest('[data-archive-photo]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.opener = link;
        this.fullImage.src = link.href;
        this.fullImage.alt = link.querySelector('img').alt;
        this.caption.textContent = link.dataset.photoCaption;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.viewer.showModal();
      };
      this.onClose = () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.fullImage.removeAttribute('src');
        this.opener?.focus();
      };
      this.addEventListener('click', this.onClick);
      this.viewer.addEventListener('close', this.onClose);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.viewer?.removeEventListener('close', this.onClose);
      if (this.viewer?.open) document.documentElement.style.overflow = this.previousOverflow || '';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infusion-photo-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('infusion-photo-carousel')) {
  customElements.define('infusion-photo-carousel', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected || this.abort) return;
      this.track = this.querySelector('.photo-gallery-track');
      this.cards = Array.from(this.querySelectorAll('.photo-gallery-item'));
      if (!this.track || this.cards.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
      this.inView = false;
      this.hovered = false;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.querySelector('.photo-gallery-buttons').hidden = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.label = this.querySelector('[data-toggle-label]');
      this.toggle.addEventListener('click', () => {
        this.playing = !this.playing;
        this.updateControls();
        this.schedule();
      }, options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.manualMove(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.manualMove(1), options);
      this.track.addEventListener('pointerdown', () => this.pause(), options);
      this.track.addEventListener('wheel', () => this.pause(), { ...options, passive: true });
      this.track.addEventListener('focusin', () => this.pause(), options);
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.manualMove(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.progressFrame);
        this.progressFrame = requestAnimationFrame(() => this.updateProgress());
      }, { ...options, passive: true });
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      }, options);
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      window.addEventListener('pagehide', () => clearTimeout(this.timer), options);
      window.addEventListener('pageshow', () => this.schedule(), options);
      this.reducedMotion.addEventListener('change', () => {
        if (this.reducedMotion.matches) this.pause();
        this.schedule();
      }, options);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
        this.schedule();
      }, { threshold: .25 });
      this.observer.observe(this.track);
      this.updateControls();
      this.updateProgress();
    }
    pause() {
      this.playing = false;
      this.updateControls();
      clearTimeout(this.timer);
    }
    updateControls() {
      this.label.textContent = this.playing ? this.label.dataset.pause : this.label.dataset.play;
      this.querySelector('[data-pause-icon]').toggleAttribute('hidden', !this.playing);
      this.querySelector('[data-play-icon]').toggleAttribute('hidden', this.playing);
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.playing || !this.inView || this.hovered || document.hidden || this.reducedMotion.matches) return;
      this.timer = setTimeout(() => {
        if (!document.body.classList.contains('menu-open') && !document.querySelector('dialog[open], [aria-modal="true"]')) this.move(1);
        this.schedule();
      }, this.interval);
    }
    positions() {
      const left = this.track.getBoundingClientRect().left;
      const max = this.track.scrollWidth - this.track.clientWidth;
      return [...new Set(this.cards.map((card) => Math.round(Math.min(max, card.getBoundingClientRect().left - left + this.track.scrollLeft))))];
    }
    move(direction) {
      const positions = this.positions();
      const left = this.track.scrollLeft;
      let target;
      if (direction > 0) target = positions.find((position) => position > left + 3) ?? 0;
      else target = positions.slice().reverse().find((position) => position < left - 3) ?? positions[positions.length - 1];
      const wrapped = direction > 0 ? target < left : target > left;
      this.track.scrollTo({ left: target, behavior: this.reducedMotion.matches || wrapped ? 'instant' : 'smooth' });
    }
    manualMove(direction) {
      this.pause();
      this.move(direction);
    }
    updateProgress() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const visible = this.track.clientWidth / this.track.scrollWidth;
      const progress = max > 0 ? visible + (1 - visible) * this.track.scrollLeft / max : 1;
      this.querySelector('.photo-gallery-progress span').style.transform = `scaleX(${progress})`;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      cancelAnimationFrame(this.progressFrame);
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listening-room"] && !Shopify.designMode) return;
  try {
    
(() => {
  let apiPromise;
  const loadPlayerAPI = () => {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      let ownedScript;
      const fail = () => {
        clearTimeout(timer);
        ownedScript?.remove();
        if (window.onYouTubeIframeAPIReady === ready) window.onYouTubeIframeAPIReady = previous;
        reject(new Error('YouTube unavailable'));
      };
      const ready = () => {
        clearTimeout(timer);
        resolve(window.YT);
        if (typeof previous === 'function') previous();
      };
      const timer = setTimeout(fail, 12000);
      window.onYouTubeIframeAPIReady = ready;
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        ownedScript = script;
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = fail;
        document.head.appendChild(script);
      }
    }).catch(error => { apiPromise = undefined; throw error; });
    return apiPromise;
  };
  if (customElements.get('infusion-listening')) return;
  customElements.define('infusion-listening', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal) return;
      this.records = [...this.querySelectorAll('[data-record]')];
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.generation = 0;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-listening-close]')) { this.dialog.close(); return; }
        if (event.target.closest('[data-next]')) { this.select((this.index + 1) % this.records.length); return; }
        if (event.target.closest('[data-previous]')) { this.select((this.index - 1 + this.records.length) % this.records.length); return; }
        const record = event.target.closest('[data-record]');
        if (!record || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        if (!/^[A-Za-z0-9_-]{11}$/.test(record.dataset.video || '')) return;
        event.preventDefault();
        this.opener = record;
        this.lockScroll();
        this.select(this.records.indexOf(record), false);
        this.dialog.showModal();
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.stopPlayer();
        this.unlockScroll();
        this.opener?.focus({preventScroll:true});
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          if (this.player?.pauseVideo) this.player.pauseVideo();
          else if (this.dialog.open) this.dialog.close();
        }
      }, options);
      window.addEventListener('pagehide', () => { if (this.dialog.open) this.dialog.close(); this.stopPlayer(); }, options);
    }
    lockScroll() {
      if (this.scrollState) return;
      const keys = ['position','top','left','right','width','overflow'];
      this.scrollState = {y:window.scrollY, styles:Object.fromEntries(keys.map(key => [key, document.body.style[key]]))};
      Object.assign(document.body.style,{position:'fixed',top:`-${this.scrollState.y}px`,left:'0',right:'0',width:'100%',overflow:'hidden'});
    }
    unlockScroll() {
      if (!this.scrollState) return;
      const state = this.scrollState;
      this.scrollState = null;
      Object.assign(document.body.style,state.styles);
      window.scrollTo({top:state.y,left:0,behavior:'instant'});
    }
    stopPlayer() {
      this.generation += 1;
      if (this.player?.destroy) this.player.destroy();
      this.player = null;
      this.querySelector('[data-listening-player]')?.replaceChildren();
    }
    select(index, focusTitle = true) {
      const record = this.records[index];
      if (!record) return;
      const videoId = record.dataset.video;
      if (!/^[A-Za-z0-9_-]{11}$/.test(videoId || '')) return;
      this.stopPlayer();
      this.index = index;
      const generation = this.generation;
      const article = record.closest('article');
      this.querySelector('[data-current-artist]').textContent = record.querySelector('[data-artist]').textContent;
      this.querySelector('[data-current-title]').textContent = record.querySelector('[data-track]').textContent;
      this.querySelector('[data-current-album]').textContent = record.querySelector('[data-album]').textContent;
      this.querySelector('[data-current-count]').textContent = `${String(index + 1).padStart(2,'0')} / ${String(this.records.length).padStart(2,'0')}`;
      ['story','why','source'].forEach(key => {
        const fragment = article.querySelector(`[data-record-${key}]`)?.content.cloneNode(true);
        this.querySelector(`[data-current-${key}]`).replaceChildren(...(fragment ? [fragment] : []));
      });
      const status = this.querySelector('[data-listening-status]');
      status.textContent = this.dataset.loading;
      this.querySelector('[data-youtube-link]').href = `https://www.youtube.com/watch?v=${videoId}`;
      const iframe = document.createElement('iframe');
      const params = new URLSearchParams({autoplay:'1',playsinline:'1',controls:'1',rel:'0',enablejsapi:'1',origin:window.location.origin});
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?${params}`;
      iframe.title = `${record.querySelector('[data-artist]').textContent} — ${record.querySelector('[data-track]').textContent}`;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.addEventListener('load', () => { if (generation === this.generation) status.textContent = this.dataset.ready; }, {once:true});
      this.querySelector('[data-listening-player]').appendChild(iframe);
      this.dialog.scrollTop = 0;
      if (focusTitle) this.querySelector('[data-current-title]').focus({preventScroll:true});
      loadPlayerAPI().then(YT => {
        if (!this.isConnected || !this.dialog.open || generation !== this.generation) return;
        this.player = new YT.Player(iframe, {events:{
          onReady: event => { if (generation !== this.generation) return; status.textContent = this.dataset.ready; if (document.hidden) event.target.pauseVideo(); },
          onAutoplayBlocked: () => { if (generation === this.generation) status.textContent = this.dataset.ready; },
          onStateChange: event => {
            if (generation !== this.generation) return;
            if (event.data === 1) { if (document.hidden) event.target.pauseVideo(); else status.textContent = this.dataset.playing; }
            else if (event.data === 2) status.textContent = this.dataset.paused;
            else if (event.data === 0) status.textContent = this.dataset.ended;
          },
          onError: () => { if (generation === this.generation) status.textContent = this.dataset.error; }
        }});
      }).catch(() => { if (generation === this.generation) status.textContent = this.dataset.ready; });
    }
    disconnectedCallback() {
      this.stopPlayer();
      this.unlockScroll();
      this.abort?.abort();
      this.abort = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
(() => {
  const header = document.querySelector('.site-header');
  const toggle = header?.querySelector('[data-menu-toggle]');
  const menu = header?.querySelector('#mobile-menu');
  if (!toggle || !menu) return;
  const mobile = window.matchMedia('(max-width: 999px)');
  const body = document.body;
  const regions = [document.querySelector('#MainContent'), document.querySelector('.site-footer')].filter(Boolean);
  let open = false;
  let scrollPosition = 0;
  let originalStyles = {};
  let regionStates = [];
  const styleKeys = ['position', 'top', 'left', 'right', 'width', 'overflow'];

  const closeMenu = (restoreFocus = true) => {
    if (!open) return;
    open = false;
    menu.hidden = true;
    menu.inert = true;
    body.classList.remove('menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = toggle.dataset.openLabel;
    styleKeys.forEach(key => { body.style[key] = originalStyles[key]; });
    regions.forEach((region, index) => { region.inert = regionStates[index]; });
    window.scrollTo({top: scrollPosition, left: 0, behavior: 'instant'});
    if (restoreFocus) toggle.focus({preventScroll: true});
  };

  const openMenu = () => {
    if (open || !mobile.matches) return;
    scrollPosition = window.scrollY;
    originalStyles = Object.fromEntries(styleKeys.map(key => [key, body.style[key]]));
    regionStates = regions.map(region => region.inert);
    open = true;
    body.classList.add('menu-open');
    Object.assign(body.style, {position: 'fixed', top: `-${scrollPosition}px`, left: '0', right: '0', width: '100%', overflow: 'hidden'});
    regions.forEach(region => { region.inert = true; });
    menu.hidden = false;
    menu.inert = false;
    menu.scrollTop = 0;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.textContent = toggle.dataset.closeLabel;
    menu.querySelector('a[href]')?.focus({preventScroll: true});
  };

  toggle.addEventListener('click', () => open ? closeMenu() : openMenu());
  menu.addEventListener('click', event => {
    if (event.target.closest('a[href]')) closeMenu(false);
  });
  document.addEventListener('keydown', event => {
    if (!open) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
    } else if (event.key === 'Tab') {
      const links = [...menu.querySelectorAll('a[href]')];
      const last = links[links.length - 1] || toggle;
      if (event.shiftKey && document.activeElement === toggle) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        toggle.focus();
      }
    }
  });
  mobile.addEventListener('change', () => {
    if (!mobile.matches) closeMenu(false);
  });
  window.addEventListener('pagehide', () => closeMenu(false));
})();

  } catch(e) { console.error(e); }
})();
})();
